import { z } from 'zod';
import { AccountCode, CcyCodeSchema, IsoDate, MoneyStr } from './common.js';
import { OrderListItem } from './order.js';

export const BalanceRow = z.object({
  account: AccountCode,
  ccy: CcyCodeSchema,
  amount: MoneyStr,
});
export type BalanceRow = z.infer<typeof BalanceRow>;

export const BalanceByAccount = z.object({
  account: AccountCode,
  rows: z.array(z.object({ ccy: CcyCodeSchema, amount: MoneyStr })),
});
export type BalanceByAccount = z.infer<typeof BalanceByAccount>;

export const TransactionRow = z.object({
  id: z.string(),
  orderId: z.string(),
  type: z.enum(['obligation', 'execution']),
  account: AccountCode,
  accountLabel: z.enum(['Клиент', 'Исполнитель']),
  ccy: CcyCodeSchema,
  amount: MoneyStr,
  status: z.enum(['pending', 'done']),
  date: IsoDate,
  provIndex: z.number().int().nullable(),
});
export type TransactionRow = z.infer<typeof TransactionRow>;

export const BalancesTimeseriesPoint = z.object({
  date: IsoDate,
  // SQL отдаёт ROUND(…, 4) — суммы соответствуют MoneyStr (≤4 знака дроби).
  debt: MoneyStr,
  cred: MoneyStr,
  net: MoneyStr,
  count: z.number().int(),
});
export type BalancesTimeseriesPoint = z.infer<typeof BalancesTimeseriesPoint>;

export const BalancesTimeseries = z.object({
  range: z.enum(['7d', '30d', '90d', '365d']),
  points: z.array(BalancesTimeseriesPoint),
});
export type BalancesTimeseries = z.infer<typeof BalancesTimeseries>;

export const DashboardCards = z.object({
  ordersTotal: z.number().int(),
  inWork: z.number().int(),
  closedToday: z.number().int(),
  profitTodayUsdt: MoneyStr,
  profitMonthUsdt: MoneyStr,
  openProvodki: z.number().int(),
});
export type DashboardCards = z.infer<typeof DashboardCards>;

export const DashboardResponse = z.object({
  cards: DashboardCards,
  recentOrders: z.array(OrderListItem),
});
export type DashboardResponse = z.infer<typeof DashboardResponse>;
